import { render, staticRenderFns } from "./WardQueue.vue?vue&type=template&id=3a18f280&scoped=true"
import script from "./WardQueue.vue?vue&type=script&lang=js"
export * from "./WardQueue.vue?vue&type=script&lang=js"
import style0 from "./WardQueue.vue?vue&type=style&index=0&id=3a18f280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a18f280",
  null
  
)

export default component.exports